/**
 * ProtectedRoute — guards routes by auth state and optional role requirement
 */
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from './useAuth';
import LoadingSpinner from '../components/common/LoadingSpinner';

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children - Protected content
 * @param {string} [props.requiredRole] - 'trainer' or 'client'. If omitted, any authenticated user.
 */
const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner fullPage />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admin has access to trainer routes (superset of trainer role)
  const roleMatches = !requiredRole
    || role === requiredRole
    || (requiredRole === 'trainer' && role === 'admin');

  if (!roleMatches) {
    // Redirect trainers/admins to trainer dashboard, clients to client dashboard
    const redirect = role === 'trainer' || role === 'admin' ? '/trainer' : '/';
    return <Navigate to={redirect} replace />;
  }

  return children;
};

export default ProtectedRoute;
